import React, { useState } from 'react';

import { Visible } from '../../core/components';
import { ItemProduct } from '../../order/components';

const OrderItem = ({
  item: order,
  manage,
  hideActionButton,
  onItemClick,
}) => {
  const [open, setOpen] = useState(!!manage);

  // Round 9 (DOM-confirmed): API occasionally returns orders with `items: []`
  // (cancelled/refunded carts that still ship in the response). Without this
  // guard, OrderItem renders an empty `<div class="order-item"></div>`, and
  // each empty wrapper draws a row separator — producing phantom divider
  // lines between real cards. Bail out for empty orders.
  if (!order?.items?.length) return null;

  const multipleItems = order.items.length > 1;

  return (
    <div className="order-item">
      {order.items.map((item, index) => {
        return (
          <ItemProduct
            key={item.id}
            {...{
              order,
              item,
              manage,
              last: index + 1 >= order.items.length,
              open,
              hideActionButton,
              onClick: () => onItemClick?.(item, order),
            }}
          />
        );
      })}

      <Visible when={multipleItems && !manage}>
        <div className={`toggler ${open ? 'open' : 'close'}`} onClick={() => setOpen(!open)}>
          <img src="/assets/icons/down-white.svg" />
        </div>
      </Visible>
    </div>
  );
};

export default OrderItem;
